import TransitionScene from '@/glxp/scenes/transitionScene'
import RAF from '@/js/utils/raf'
import view from '@/mixins/view'

import { TweenMax } from 'gsap'

let _timeout = setTimeout(() => {}, 0)

export default {
  name: 'transition',
  mixins: [view],
  data () {
    return {
      bgc: {
        backgroundColor: ''
      },
      state: 'hidden'
    }
  },
  watch: {
    'bgc.backgroundColor': function (val, oldVal) {
      if (this.glxp) {
        this.glxp.setBackgroundColor(val)
      }
    }
  },
  created () {
    this.overideHide = false
    this.$store.state.transition.components.default = this
  },
  mounted () {
    this.state = 'before'
    this.$nextTick(() => {
      this.glxp = new TransitionScene(this.$refs['transition-container'])
      this.glxp.load()
      this.glxp.mobile = !!this.mobile
      this.$nextTick(() => {
        this.bgc.backgroundColor = window.quote ? window.quote.color : '#4c5b75'
        this.state = 'hidden'
      })
    })
  },
  computed: {

  },
  methods: {
    show () {
      this.state = 'hidden'
      this.$nextTick(() => {
        this.state = 'visible'
        this.glxp.resize()
        this.glxp.onResize()
        RAF.suscribe('transition', this.update.bind(this))
        if (this.overideHide == false) {
          TweenMax.fromTo(this.glxp, 1, {
            offset: 1,
            shift: 0.08
          }, {
            offset: 0,
            shift: 0,
            ease: Power2.easeInOut
          })
        }
      })
    },
    hide () {
      if (this.overideHide == true) {
        return
      }
      clearTimeout(_timeout)
      TweenMax.killTweensOf(this.glxp)
      TweenMax.to(this.glxp, 1, {
        offset: -0.5,
        shift: -0.08
      })
      _timeout = setTimeout(() => {
        this.state = 'hidden'
        RAF.unsuscribe('transition')
      }, 2000)
    },

    showImgTransition () {
      let activeLink = this.$store.state.transition.entry
      this.$refs['transition-container'].classList.add('image')
      activeLink.style.pointerEvents = 'none'

      let image
      if (activeLink._component) {
        let clientComponent = activeLink._component.$children[0].$children[0]
        let titleComponent = activeLink._component.$children[0].$children[1]
        image = activeLink._component.image
        clientComponent.hide('up')
        setTimeout(() => {
          titleComponent.hide('up')
        }, 200)
      } else {
        image = activeLink.querySelector('img').src
        activeLink.style.visibility = 'hidden'
      }
      let bounds
      if (activeLink.getAttribute('data-origin') === 'slider') {
        bounds = activeLink.getBoundingClientRect()
      } else {
        bounds = activeLink.querySelector('img').getBoundingClientRect()
      }

      this.state = 'hidden'
      this.$nextTick(() => {
        this.state = 'visible'
        this.glxp.resize()
        this.glxp.onResize()
        this.glxp.startImageTransition(image, bounds)
        RAF.suscribe('transition', this.update.bind(this))
      })
    },

    hideImgTransition () {
      this.$refs['transition-container'].classList.remove('image')
      clearTimeout(_timeout)
      _timeout = setTimeout(() => {
        this.state = 'hidden'
        // this.glxp.removeImageTransition()
        RAF.unsuscribe('transition')
      }, this.platform === 'mobile' ? 1000 : 1700)
    },

    animateIn () {

    },

    update () {
      this.glxp.render()
    }
  }
}
